// @flow strict

export const SET_STEP = 'SET_STEP';
